import { fetchAllIconsFromKodefastAPI } from "@/repo/iconsRepo";
const initiateState = () => {
  return {
    apiIcons: [],
  };
};

const state = initiateState();

const getters = {
  getApiIcons: (state) => state.apiIcons,
};

const mutations = {
  setApiIcons(state, icons) {
    state.apiIcons = icons;
  },
};

const actions = {
  fetchApiIcons: async (context) => {
    try {
      const icons = await fetchAllIconsFromKodefastAPI();
      context.commit("icons/setApiIcons", icons, { root: true });
    } catch (error) {
      context.commit("icons/setApiIcons", [], { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
